import { gql } from "@urql/core";

const NodeUpdateManyMut = `
  mutation updateNodes($input:UpdateNodesInput!) {
    updateNodes(
      input: $input) {
      status
      message
    }
  }
`;

const NodeCreateMut = gql`
  mutation createProjectNode($input: CreateProjectNodeInput!) {
    createProjectNode(input: $input) {
      id
      title
      kind
      referencePosition
      parentId
      systemPath
      localPath
    }
  }
`;

const NodeCreateManyMut = `
  mutation createNodes($input :CreateNodesInput!) {
    createNodes(
      input: $input
    ) {
      status
      message
    }
  }
`;

const NodeDeleteManyMut = `
  mutation deleteNodes($input: DeleteNodesInput!) {
    deleteNodes(
      input: $input
    ) {
      status
      message
    }
  }
`;

const ProcessNodesMut = `
  mutation processNodes($input: ProcessNodesInput!) {
    processNodes(input: $input) {
      message
      status
    }
  }
`;

// used also for moving the node (and its children) from one position to another
const NodeUpdateMut = gql`
  mutation updateProjectNode($input: UpdateProjectNodeInput) {
    updateProjectNode(input: $input) {
      id
      title
      kind
      configurations
      referencePosition
      parentId
      nodes
      systemPath
      localPath
    }
  }
`;

const NodeDeleteMut = gql`
  mutation deleteProjectNode($input: DeleteProjectNodeInput!) {
    deleteProjectNode(input: $input) {
      id
      title
      kind
      referencePosition
      parentId
      nodes
      systemPath
      localPath
    }
  }
`;

const NodeCopyMut = gql`
  mutation copyProjectNode($input: CopyProjectNodeInput) {
    copyProjectNode(input: $input) {
      id
      title
      kind
      referencePosition
      configurations
      parentId
      nodes
      systemPath
      localPath
    }
  }
`;

export {
  NodeCreateMut,
  NodeUpdateMut,
  NodeDeleteMut,
  ProcessNodesMut,
  NodeCopyMut,
  NodeUpdateManyMut,
  NodeCreateManyMut,
  NodeDeleteManyMut,
};
